module.exports = __webpack_public_path__ + "img/site_09_bak.0e62e4de.png";